module.exports = __webpack_public_path__ + "img/wap_daren_en3.0a4a1653.jpg";